import React, { useCallback, useEffect } from 'react'

import { useRecoilValue, useRecoilCallback } from 'recoil'

import { Loading, Panel, Grid, GridCell } from 'mailup-web-components'

import ErrorFeedback from 'Components/ErrorFeedback'

import Header from './components/Header'

import TimeStatus from './components/TimeStatus'
import RecipientsStatus from './components/RecipientsStatus'

import UpdateButton from './components/UpdateButton'

import { pageState } from 'Pages/SMTPPlusSendStatus/recoil/state/page'
import { fetchSendingsCallback } from 'Pages/SMTPPlusSendStatus/recoil/callbacks/callbacks'

const SMTPPlusSendStatus = () => {
  const { loading, loaded, error, severity } = useRecoilValue(pageState)
  const fetchSendings = useRecoilCallback(fetchSendingsCallback, [])

  const reloadPage = useCallback(() => {
    window.location.reload()
  }, [])

  useEffect(() => {
    fetchSendings()
  }, [])

  return (
    <>
      <Loading open={loading} />
      <Header />
      <div className='l-container'>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={reloadPage}
          className='l-smtpplus-send-status__error-feedback'
        />
        {!error && loaded && (
          <>
            <Panel>
              <Grid cols={12}>
                <GridCell span={5}>
                  <TimeStatus />
                </GridCell>
                <GridCell span={7}>
                  <RecipientsStatus />
                </GridCell>
              </Grid>
            </Panel>
            <UpdateButton />
          </>
        )}
      </div>
    </>
  )
}

/* display: grid;
  grid-gap: 0;
  grid-template-columns: minmax(0, 5fr) minmax(0, 7fr); */

export default SMTPPlusSendStatus
